import { TriStateCheckboxTogether } from 'react-together-primereact'

export function PrimeReactTriStateCheckboxTogetherDemo() {
  return (
    <div className='flex-col place-items-center'>
      <TriStateCheckboxTogether rtKey='tri-state-checkbox-doc-demo' />
    </div>
  )
}
